// extracted by mini-css-extract-plugin
export default {"customTooltip":"DistanceTooltip_customTooltip__NWApc","tooltipLabel":"DistanceTooltip_tooltipLabel__NN3Qq","tooltipValue":"DistanceTooltip_tooltipValue__VJlxg"};